import { useEffect, useState } from "react";
import * as api from "../../requests";

const useConfig = (authType) => {
    const [config, setConfig] = useState();

    useEffect(() => {
        if(config === undefined) {
            api.ND_AUTH_SETTINGS_GET(
                authType,
                (response) => {
                    setConfig(response);
                }, (err) => {
                    console.error(err);
                }
            );
        }
    });

    return [config];
};

export default useConfig;